import Props from '@service-victoria/component-library/props';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { lazy } from 'react';
import * as Yup from 'yup';

import formData from 'form/formData';
import { TransactionSteps, ReviewStep } from 'interfaces/transaction';
import registrationService from 'services/registrationService';
import { GenericValidationErrors } from 'utils/constants';
import { doesNotContainEmoji } from 'utils/validations';

import next from '../Done/meta';
import meta, { Values } from './meta';

export const initialValues: ReviewStep = {
  roleTitle: '',
  confirm: false
};

export const initialErrors: FormikErrors<ReviewStep> = {};
export const initialTouched: FormikTouched<ReviewStep> = {};

export const ReviewSchema = Yup.object().shape<ReviewStep>({
  roleTitle: Yup.string()
    .required(GenericValidationErrors.required)
    .test(
      'doesNotContainEmoji',
      "That doesn't look like a valid role title. Please try again",
      doesNotContainEmoji
    )
    .test('isValid', GenericValidationErrors.required, function isValid(str?: string) {
      return (str?.length ?? 0) > 0;
    }),
  confirm: Yup.boolean()
    .required()
    .test('isTicked', GenericValidationErrors.mandatoryCheckbox, function (val?: boolean) {
      return !!val;
    })
});

const validationSchema = Yup.object().shape<Values>({
  review: ReviewSchema
}) as Yup.Schema<Values>;

const Step: Props.Wizard.Step<TransactionSteps> = {
  ...meta,
  Component: lazy(() => import('./Review')),
  validation: {
    // @ts-expect-error - We only need to validate the review step, but we need the values of the whole TransactionSteps... This works fine, just typed poorly at source.
    schema: validationSchema,
    fieldNames: formData.review.map(({ id }) => `review.${id}`)
  },
  navigation: {
    normal: [
      {
        content: 'Submit',
        shouldValidate: true,
        isSubmit: true,
        type: 'primary',
        onClick: async (
          context: Props.Wizard.StepConsumerContext<TransactionSteps>,
          form: FormikProps<TransactionSteps>
        ) => {
          try {
            form.setFieldValue('submitError', undefined);
            form.setSubmitting(true);
            await registrationService.submitPayload(form.values);

            context.dispatch({
              type: 'GOTO_STEP',
              stepId: next.id,
              delayedLoadingMs: 500,
              values: undefined
            });
          } catch (e) {
            form.setFieldValue(
              'submitError',
              'Sorry, there was a problem processing this request.',
              false
            );
          } finally {
            form.setSubmitting(false);
          }
        }
      },
      {
        content: 'Back',
        type: 'secondary',
        onClick: (context: Props.Wizard.StepConsumerContext<TransactionSteps>, form): void => {
          context.dispatch({
            type: 'GOTO_STEP',
            stepId: form.values.worksite.siteType,
            delayedLoadingMs: 500,
            values: undefined
          });
        }
      }
    ],
    order: 'descending'
  }
};

export { Step };
